export default {"src":"/_next/static/media/ic-arrow-register.a2db5c19.svg","height":16,"width":24,"blurWidth":0,"blurHeight":0};